// client/customer/src/utils/reservation/by-Date/postCreateReservation.ts
import apiConfig from '../../../apiConfig';
import { getCustomerAuthHeaders } from '../../auth/customerAuthToken';

export type CreateReservationServiceItem = {
  service_id: number;
};

export type PostCreateReservationByDatePayload = {
  storeId: number;
  customerId?: number | null;
  customerName?: string | null; // 通知用（任意）
  date: string; // 'YYYY-MM-DD'
  staffId: number | null;
  isFree?: boolean;
  startTime: string; // 'HH:mm'
  services: CreateReservationServiceItem[]; // 順番が連結施術の順番
  
};

export type PostCreateReservationByDateResponse = {
  message: string;
  reservation_id: number;
};

export const postCreateReservationByDate = async (
  payload: PostCreateReservationByDatePayload
): Promise<PostCreateReservationByDateResponse> => {
  const res = await fetch(`${apiConfig.baseURL}/api/customer-app/reservation/by-date/create`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...getCustomerAuthHeaders(),
    },
    body: JSON.stringify({
      store_id: payload.storeId,
      customer_id: payload.customerId ?? null,
      customer_name: payload.customerName ?? null,
      date: payload.date,
      staff_id: payload.staffId,
      is_free: payload.isFree === true,
      start_time: payload.startTime,
      services: payload.services,
      
    }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error || 'Failed to create reservation');
  }

  return (await res.json()) as PostCreateReservationByDateResponse;
};
